import axios, { AxiosRequestConfig } from 'axios'
import {
  ReadClientTypesForAssignToUserRequestDto,
  ReadClientTypesForAssignToUserResponseDto,
  UserClientTypeRequestDto,
  UserClientTypeResponseDto,
  WebAccessTokenPayloadDto,
} from '@sparling/financial-common'
import { isNil } from 'lodash'

export const fetchUser = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<WebAccessTokenPayloadDto> => {
  const response = await axios.get<WebAccessTokenPayloadDto>(`${process.env.REACT_APP_REST_API_URL}/web/user-info`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.data
}

export const fetchClientTypesForAssignToUser = async (
  { token, ...params }: ReadClientTypesForAssignToUserRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadClientTypesForAssignToUserResponseDto> => {
  const response = await axios.get<ReadClientTypesForAssignToUserResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/web/client-types`,
    {
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const userClientTypeChangeRequest = async (
  { token, ...data }: UserClientTypeRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UserClientTypeResponseDto> => {
  const response = await axios.post<UserClientTypeResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/client-type`,
    data,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}
